import request from "@/utils/request";
let OrderApi = {
  /*订单列表*/
  orderlist(data, errorback) {
    return request._post("/shop/order.order/index", data, errorback);
  },
  /*订单列表*/
  tgorderlist(data, errorback) {
    return request._post("/shop/order.order/tgindex", data, errorback);
  },
  /*订单详情*/
  orderdetail(data, errorback) {
    return request._post("/shop/order.order/detail", data, errorback);
  },
  /*售后管理*/
  orderrefund(data, errorback) {
    return request._post("/shop/order.refund/index", data, errorback);
  },
  /*租后订单*/
  orderlist1(data, errorback) {
    return request._post("/shop/order.order/zhindex", data, errorback);
  },
  /*待还租期*/
  orderlist2(data, errorback) {
    return request._post("/shop/order.order/dhindex", data, errorback);
  },
  /*租后订单*/
  orderlist1(data, errorback) {
    return request._post("/shop/order.order/zhindex", data, errorback);
  },
  /*订单逾期*/
  orderlist4(data, errorback) {
    return request._post("/shop/order.order/yqindex", data, errorback);
  },
  /*多笔订单*/
  orderlist5(data, errorback) {
    return request._post("/shop/order.order/duobiindex", data, errorback);
  },
  /*已还列表*/
  orderlist3(data, errorback) {
    return request._post("/shop/order.order/yhindex", data, errorback);
  },
  updateOrderInfo(data, errorback) {
    return request._post("/shop/order.order/updateOrderInfo", data, errorback);
  },
  /*去发货*/
  delivery(data, errorback) {
    return request._post("/shop/order.order/delivery", data, errorback);
  },
  /*确认审核*/
  confirmCancel(data, errorback) {
    return request._post("/shop/order.Operate/confirmCancel", data, errorback);
  },
  /*售后详情*/
  refundDetail(data, errorback) {
    return request._get("/shop/order.refund/detail", data, errorback);
  },
  /*售后审核*/
  Approval(data, errorback) {
    return request._get("/shop/order.refund/audit", data, errorback);
  },
  /*确认收货并退款*/
  receiptOrder(data, errorback) {
    return request._post("/shop/order.refund/receipt", data, errorback);
  },
  /*核销*/
  extract(data, errorback) {
    return request._post("/shop/order.operate/extract", data, errorback);
  },
  /*修改价格*/
  updatePrice(data, errorback) {
    return request._post("/shop/order.order/updatePrice", data, errorback);
  },
  /*平台售后管理*/
  orderplaterefund(data, errorback) {
    return request._post("/shop/order.platerefund/index", data, errorback);
  },
  /*平台售后详情*/
  refundplateDetail(data, errorback) {
    return request._get("/shop/order.platerefund/detail", data, errorback);
  },
  /*平台售后审核*/
  plateApproval(data, errorback) {
    return request._get("/shop/order.platerefund/audit", data, errorback);
  },
  queryLogistics(data, errorback) {
    return request._post("/shop/order.order/express", data, errorback);
  },
  updateAddress(data, errorback) {
    return request._post("/shop/order.order/updateAddress", data, errorback);
  },
  /*归还审核*/
  toExamine1(data, errorback) {
    return request._post("/shop/order.Operate/toExamine", data, errorback);
  },
  /*归还审核*/
  contract(data, errorback) {
    return request._post(
      "/shop/order.contract/createByDo" + "cTemplate",
      data,
      errorback
    );
  },
  /*租期列表*/
  billinfo(data, errorback) {
    return request._get("/shop/order.Operate/billinfo", data, errorback);
  },
  /*手动扣款*/
  toExamine(data, errorback) {
    return request._post("/shop/order.Operate/checkbill", data, errorback);
  },
  /*提交预金*/
  yushou(data, errorback) {
    return request._post("/shop/order.Operate/yushou", data, errorback);
  },
  /*删除订单*/
  delete(data, errorback) {
    return request._post("/shop/order.order/delete", data, errorback);
  },
  /*多选删除订单*/
  deleteall(data, errorback) {
    return request._post("/shop/order.order/deleteall", data, errorback);
  },
  /*确认订单*/
  receipt(data, errorback) {
    return request._post("/shop/order.order/receipt", data, errorback);
  },
  /*确认订单*/
  receipt2(data, errorback) {
    return request._post("/shop/order.refund/receipt", data, errorback);
  },
  /*查看签署*/
  FlowDetail(data, errorback) {
    return request._post(
      "/shop/order.contract/queryFlowDetail",
      data,
      errorback
    );
  },
  /*押金转租金*/
  zhuanzujin(data, errorback) {
    return request._post("/shop/order.Operate/zhuanzujin", data, errorback);
  },
  /*操作备注*/
  orderRemarks(data, errorback) {
    return request._post("/shop/order.order/orderRemarks", data, errorback);
  },
  /*资金解冻*/
  ysunfreeze(data, errorback) {
    return request._post("/shop/order.Operate/ysunfreeze", data, errorback);
  },
  /*租期*/
  zuqi(data, errorback) {
    return request._post("/shop/order.order/zuqi", data, errorback);
  },
  /*三要素*/
  sanyao(data, errorback) {
    return request._post(
      "/shop/yunxin.query2/testBooleanDemo",
      data,
      errorback
    );
  },
  /*详情逾期代偿报送*/
  hkbs(data, errorback) {
    return request._post("/shop/yunxin.query1/hkbs", data, errorback);
  },
  /*详情主动还款报送*/
  yqhkbs(data, errorback) {
    return request._post("/shop/yunxin.query1/yqhkbs", data, errorback);
  },
  /*查询合同*/
  chaxun(data, errorback) {
    return request._post(
      "/shop/mayilian.mayilian/querySigningProcessStatus",
      data,
      errorback
    );
  },
  /*下载签署文档*/
  xiazai(data, errorback) {
    return request._post(
      "/shop/mayilian.mayilian/downloadSigningDocument",
      data,
      errorback
    );
  },
  /*下载签署文档*/
  xiazai2(data, errorback) {
    return request._post("/shop/order.contract/downloadFile", data, errorback);
  },
  /*蚂蚁链代扣列表*/
  mayiliandaikou(data, errorback) {
    return request._post("/shop/mayilian.mayilian/list", data, errorback);
  },
  /*蚂蚁链代扣回调列表*/
  mayiliandaikouhui(data, errorback) {
    return request._post(
      "/shop/mayilian.mayilian/listFeedback",
      data,
      errorback
    );
  },
  /*订单备注*/
  saveopt(data, errorback) {
    return request._post("/shop/order.order/saveopt", data, errorback);
  },
  /*代扣解约*/
  daikoujieyue(data, errorback) {
    return request._post(
      "/shop/mayilian.mayilian/withholdingCancellation",
      data,
      errorback
    );
  },
  /*多笔订单 */
  getduobilist(data, errorback) {
    return request._post("/shop/order.order/getduobilist", data, errorback);
  },
  /*手动扣款输入密码*/
  checkpwd(data, errorback) {
    return request._post("/shop/order.Operate/checkpwd", data, errorback);
  },
  /*查询物流*/
  queryWL(data, errorback) {
    return request._post("/shop/order.order/express", data, errorback);
  },
  /*商家备注*/
  saveopt(data, errorback) {
    return request._post("/shop/order.order/saveopt", data, errorback);
  },
  /*取消/已还*/
  setbill(data, errorback) {
    return request._post("/shop/order.Operate/setbill", data, errorback);
  },
  /*e签宝查询认证信息*/
  queryAttestation(data, errorback) {
    return request._post(
      "/shop/order.authentication/queryAttestation",
      data,
      errorback
    );
  },
  /*主动还款密码验证*/
  checkpwd2(data, errorback) {
    return request._post("/shop/order.operate/checkpwd2", data, errorback);
  },
  /*订单详情分期主动还款*/
  activeRepayment(data, errorback) {
    return request._post(
      "/shop/order.operate/activeRepayment",
      data,
      errorback
    );
  },
  /*订单外页点击亲属手机号*/
  searchMobile(data, errorback) {
    return request._post("/shop/order.ali_cloud/phoneStatus", data, errorback);
  },
  /*订单详情页取消买断*/
  quxiaomaiduan(data, errorback) {
    return request._post("/shop/order.order/user_buyout", data, errorback);
  },
  /*下载用户授权协议和个人信息授权书到服务器*/
  downloadAgreement(data, errorback) {
    return request._post(
      "/shop/mayilian.mayilian/downloadAgreement",
      data,
      errorback
    );
  },
  /*修改商品*/
  checkproduct(data, errorback) {
    return request._post("/shop/order.operate/checkproduct", data, errorback);
  },
  /*修改物流*/
  testBooleanDemo(data, errorback) {
    return request._post(
      "/shop/yunxin.query1/testBooleanDemo",
      data,
      errorback
    );
  },
  /*申请上报*/
  checkdelivery(data, errorback) {
    return request._post("/shop/order.order/checkdelivery", data, errorback);
  },
  /*申请上报*/
  fkbs(data, errorback) {
    return request._post("/shop/yunxin.query1/fkbs", data, errorback);
  },
  /*结清*/
  jieqing(data, errorback) {
    return request._post("/shop/yunxin.query1/jieqing", data, errorback);
  },
  /*完成*/
  wancheng(data, errorback) {
    return request._post("/shop/order.operate/wancheng", data, errorback);
  },
  /*删除蚂蚁链合同*/
  deletehetong(data, errorback) {
    return request._post("/shop/order.operate/deletehetong", data, errorback);
  },
  /*分配客户列表*/
  authuser(data, errorback) {
    return request._post("/shop/auth.user/index", data, errorback);
  },
  /*分配客户确认*/
  setadmin(data, errorback) {
    return request._post("/shop/order.operate/setadmin", data, errorback);
  },
  /*分配客户确认*/
  zhflzt(data, errorback) {
    return request._post("/shop/order.operate/flzt", data, errorback);
  },
  /*蚂蚁链投诉详情*/
  tsddcx(data, errorback) {
    return request._post("/shop/mayilian.mayilian/tsddcx", data, errorback);
  },
  /*蚂蚁链反馈*/
  tsfk(data, errorback) {
    return request._post("/shop/mayilian.mayilian/tsfk", data, errorback);
  },
  /*新租后订单*/
  newdhindex(data, errorback) {
    return request._post("/shop/order.order/newdhindex", data, errorback);
  },
  /*当月租期订单*/
  shortdhindex(data, errorback) {
    return request._post("/shop/order.order/shortdhindex", data, errorback);
  },
  /*/ 申请提现列表*/
  withdrawalList(data, errorback) {
    return request._post(
      "/shop/withdrawal.withdrawal/withdrawalList",
      data,
      errorback
    );
  },
  /*审核提现*/
  withdrawalAudit(data, errorback) {
    return request._post(
      "/shop/withdrawal.withdrawal/withdrawalAudit",
      data,
      errorback
    );
  },
  /*总账单*/
  zhangdan(data, errorback) {
    return request._post("/shop/order.order/zhangdan", data, errorback);
  },
  /*分配客户*/
  setSupplier(data, errorback) {
    return request._post("/shop/order.operate/setSupplier", data, errorback);
  },
  /*下载*/
  downloadByAttachName(data, errorback) {
    return request._post(
      "/shop/aiqian.aiqian/downloadByAttachName",
      data,
      errorback
    );
  },
  /*上传物流单*/
  upwlhz(data, errorback) {
    return request._post("/shop/order.operate/upwlhz", data, errorback);
  },
  /*上传代偿证明*/
  updczm(data, errorback) {
    return request._post("/shop/order.operate/updczm", data, errorback);
  },
  /*上传代偿证明书*/
  updctzs(data, errorback) {
    return request._post("/shop/order.operate/updctzs", data, errorback);
  },
  /*短信催缴截图*/
  updxcjjt(data, errorback) {
    return request._post("/shop/order.operate/updxcjjt", data, errorback);
  },
  /*物权证明*/
  upwqzm(data, errorback) {
    return request._post("/shop/order.operate/upwqzm", data, errorback);
  },
  /*违约金*/
  tongzhi(data, errorback) {
    return request._post("/shop/order.order/tongzhi", data, errorback);
  },
  /*获取违约金*/
  tongzhi2(data, errorback) {
    return request._get("/shop/order.order/tongzhi", data, errorback);
  },
  /*导出PDF*/
  createpdf(data, errorback) {
    return request._post("/shop/order.order/createpdf", data, errorback);
  },
  /*预充值接口*/
  preRecharge(data, errorback) {
    return request._post("/shop/order.order/preRecharge", data, errorback);
  },
  /* 赋强下载合同*/
  gongzhengurl(data, errorback) {
    return request._post("/shop/gongzheng.index/gongzhengurl", data, errorback);
  },
  /* 赋强下载合同*/
  gongzhengurl1(data, errorback) {
    return request._post("/shop/gongzheng.index/gongzhengurl", data, errorback);
  },
  // 扣款
  Deductmoney(data, errorback) {
    return request._post("/shop/withhold.SinglePay/SinglePay", data, errorback);
  },
  /* 赋强公正取消*/
  gzCancel(data, errorback) {
    return request._post("/shop/gongzheng.index/cancel", data, errorback);
  },
  /* 赋强公正同意*/
  gzApproval(data, errorback) {
    return request._post("/shop/gongzheng.index/approval", data, errorback);
  },
  /* 赋强公正拒绝*/
  gzReject(data, errorback) {
    return request._post("/shop/gongzheng.index/reject", data, errorback);
  },
  /* 赋强公正拒绝*/
  gzReject(data, errorback) {
    return request._post("/shop/gongzheng.index/reject", data, errorback);
  },
  /* 赋强公正查看证书*/
  queryApplyInfo(data, errorback) {
    return request._post(
      "/shop/gongzheng.index/queryApplyInfo",
      data,
      errorback
    );
  },
  // 获取还款筛选列表
  getShortdhindex(data, errorback) {
    return request._post("/shop/order.order/shortdhindex", data, errorback);
  },
  // 扣款
  Deductmoney(data, errorback) {
    return request._post("/shop/withhold.SinglePay/SinglePay", data, errorback);
  },
  // 浩程达
  // 生成还款计划
  createRepayPlan(data, errorback) {
    return request._post(
      "/shop/xiongyi.index/createRepayPlan",
      data,
      errorback
    );
  },
  // 开户
  load(data, errorback) {
    return request._post("/shop/xiongyi.index/loan", data, errorback);
  },
  // 还款
  creditRepay(data, errorback) {
    return request._post("/shop/xiongyi.index/creditRepay", data, errorback);
  },
  // 结清
  creditSettle(data, errorback) {
    return request._post("/shop/xiongyi.index/creditSettle", data, errorback);
  },
  // 获取用户信息
  getUserInfo(data, errorback) {
    return request._get("/shop/xiongyi.index/getUserInfo", data, errorback);
  },
  // 文件转base64
  getBase(data, errorback) {
    return request._post("/shop/xiongyi.index/fileToBase64", data, errorback);
  },
  // 生成还款计划 获取具体订单金额
  getBill(data, errorback) {
    return request._get("/shop/xiongyi.index/getBill", data, errorback);
  },
  // 支付宝支付
  aliPayOrderBi(data, errorback) {
    return request._post("/shop/order.order/aliPayOrderBill", data, errorback);
  },
  // 蚂蚁链生成合同
  createOrderchain(data, errorback) {
    return request._post("/shop/order.orderchain/index", data, errorback);
  },
  // 蚂蚁链代扣解约申请
  cancelChain(data, errorback) {
    return request._post(
      "/shop/order.orderchain/antchainAtoWithholdSignasyncunsignConfirm",
      data,
      errorback
    );
  },
  // 蚂蚁链-未到期代扣批量取消  解约申请成功的前置  取消订单
  antchainAtoWithholdPlanCancel(data, errorback) {
    return request._post(
      "/shop/order.orderchain/antchainAtoWithholdPlanCancel",
      data,
      errorback
    );
  },
  // 订单关闭
  closeOrder(data, errorback) {
    return request._post("/shop/order.orderchain/closeOrder", data, errorback);
  },
  // 驳回是否
  verifySupplyFile(data, errorback) {
    return request._post(
      "shop/order.operate/verifySupplyFile",
      data,
      errorback
    );
  },

  // 设置设备号
  setEquipmentNo(data, errorback) {
    return request._post("/shop/order.Jindun/index", data, errorback);
  },
  // 查询设备信息
  getShe(data, errorback) {
    return request._post("/shop/order.Jindun/getShe", data, errorback);
  },
  // 设置设备信息
  setShe(data, errorback) {
    return request._post("/shop/order.Jindun/setShe", data, errorback);
  },
  // 设备控制
  command(data, errorback) {
    return request._post("/shop/order.Jindun/command", data, errorback);
  },
  // 丢失模式
  lost(data, errorback) {
    return request._post("/shop/order.Jindun/lost", data, errorback);
  },
  // 配置默认APP限制
  appConfig(data, errorback) {
    return request._post("/shop/order.Jindun/app", data, errorback);
  },
  // 配置默认功能限制
  systemConfig(data, errorback) {
    return request._post("/shop/order.Jindun/system", data, errorback);
  },
  // 配置默认壁纸
  wallpaper(data, errorback) {
    return request._post("/shop/order.Jindun/wallpaper", data, errorback);
  },
  // 移除激活锁
  removeLock(data, errorback) {
    return request._post("/shop/order.Jindun/lock", data, errorback);
  },
  // 查看激活锁密码
  lookPassword(data, errorback) {
    return request._post("/shop/order.Jindun/password", data, errorback);
  },
  // ABM解绑
  unbindAbm(data, errorback) {
    return request._post("/shop/order.Jindun/abm", data, errorback);
  } /*备注*/,
  addRemark(data, errorback) {
    return request._post("/shop/order.operate/addRemark", data, errorback);
  },
  /*坏账*/
  billDebt(data, errorback) {
    return request._post("/shop/order.operate/billDebt", data, errorback);
  },
  /*获取操作记录*/
  orderLog(data, errorback) {
    return request._post("/shop/order.order/orderLog", data, errorback);
  },
  /*合计进货价*/
  orderPurchase(data, errorback) {
    return request._post("shop/order.operate/orderPurchase", data, errorback);
  },
  createRefund(data, errorback) {
    return request._post(
      "/shop/order.orderchain/createRefund",
      data,
      errorback
    );
  },
  // 对账单查询
  capital(data, errorback) {
    return request._post("/shop/cash.cash/capital", data, errorback);
  },

  /** 查询支付状态 */
  queryTrade(data, errorback) {
    return request._get(
      "/shop/order.merchantWithholding/queryTrade",
      data,
      errorback
    );
  },
  /** 查看订单状态 */
  queryOrder(data, errorback) {
    return request._get(
      "/shop/order.merchantWithholding/queryOrder",
      data,
      errorback
    );
  },
  /** 用户解约 */
  cancelSign(data, errorback) {
    return request._get(
      "/shop/order.merchantWithholding/cancelSign",
      data,
      errorback
    );
  },
  // 主动还款
  payWithholding(data, errorback) {
    return request._post(
      "/shop/order.merchantWithholding/payWithholding",
      data,
      errorback
    );
  },
  restoreWithholding(data, errorback) {
    return request._get(
      "/shop/order.merchantWithholding/restoreWithholding",
      data,
      errorback
    );
  },
  // 分期退款
  refundWithholding(data, errorback) {
    return request._get(
      "/shop/order.merchantWithholding/refundWithholding",
      data,
      errorback
    );
  },
  // 审核代扣签约
  auditWithholding(data, errorback) {
    return request._post("shop/order.operate/signValidate", data, errorback);
  },
  auditCancelWithholding(data, errorback) {
    return request._get(
      "/shop/order.merchantWithholding/doHandleUnsign",
      data,
      errorback
    );
  },
  billRefund(data, errorback) {
    return request._get("/shop/order.order/billOrderRefund", data, errorback);
  },
  terminateORder(data, errorback) {
    return request._get(
      "/shop/order.order/getApplyTerminateList",
      data,
      errorback
    );
  },
  reqeceiptImg(data, errorback) {
    return request._get("/shop/order.order/setReceiptImages", data, errorback);
  },
  mianyaRefund(data, errorback) {
    return request._post(
      "/shop/order.operate/mianyaRefundExecute",
      data,
      errorback
    );
  },
  bigOrderBillPay(data, errorback) {
    return request._post(
      "/shop/order.operate/activePayOrderAlipayBill",
      data,
      errorback
    );
  },
  ghReturn(data, errorback) {
    return request._post("/shop/order.order/return", data, errorback);
  }
};

export default OrderApi;



// WEBPACK FOOTER //
// ./src/api/order.js